import { https, httpsMultipart } from 'shared/utils/https';
import type {
  IGetHierarchyItemsResponse,
  IGetHierarchySubitemsResponse,
  IPostHierarchyTreeItemsOrder,
  IPostHierarchyTreeSubitemBody,
  IPostHierarchyTreeSubitemsOrder,
  IPutHierarchyTreeSubitemBody,
} from './hierarchy.dto';

const treesPath = '/v1/navigations';

export const hierarchyData = {
  getHierarchyItems: async (id: string): Promise<IGetHierarchyItemsResponse> => {
    const { data } = await https.get<IGetHierarchyItemsResponse>(`${treesPath}/${id}/items`);
    return data;
  },
  getHierarchySubitems: async (treeId: string, itemId: string): Promise<IGetHierarchySubitemsResponse> => {
    const { data } = await https.get<IGetHierarchySubitemsResponse>(`${treesPath}/${treeId}/items/${itemId}/subitems`);
    return data;
  },

  createHierachyItem: async (body: FormData, treeId: string): Promise<void> =>
    httpsMultipart.post(`${treesPath}/${treeId}/items`, body),

  editHierachyItem: async (body: FormData, treeId: string, itemId: string): Promise<void> =>
    httpsMultipart.patch(`${treesPath}/${treeId}/items/${itemId}`, body),

  createHierachySubitem: async (body: IPostHierarchyTreeSubitemBody): Promise<void> => {
    const { treeId, itemId, ...restOfParams } = body;
    await https.post(`${treesPath}/${treeId}/items/${itemId}/subitems`, restOfParams);
  },

  editHierachySubitem: async (body: IPutHierarchyTreeSubitemBody): Promise<void> => {
    const { treeId, itemId, subItemId, ...restOfParams } = body;
    await https.patch(`${treesPath}/${treeId}/items/${itemId}/subitems/${subItemId}`, restOfParams);
  },

  deleteHierarchyItem: async (id: string, treeId: string): Promise<void> => {
    await https.delete<void>(`${treesPath}/${treeId}/items/${id}`);
  },

  deleteHierarchySubitem: async (id: string, itemId: string, treeId: string): Promise<void> => {
    await https.delete<void>(`${treesPath}/${treeId}/items/${itemId}/subitems/${id}`);
  },

  publishHierachyTrees: async (id: string): Promise<void> => {
    await https.post<void>(`${treesPath}/${id}/publish`);
  },

  updateHierarchyItemsOrder: async (body: IPostHierarchyTreeItemsOrder) => {
    const { treeId, ...restOfParams } = body;
    await https.post(`${treesPath}/${treeId}/items/arrange`, restOfParams);
  },

  updateHierarchySubtemsOrder: async (body: IPostHierarchyTreeSubitemsOrder) => {
    const { treeId, itemId, ...restOfParams } = body;
    await https.post(`${treesPath}/${treeId}/items/${itemId}/subitems/arrange`, restOfParams);
  },
};
